export enum PERMISSION_IDS {
  VIEWER = 0,
  CONSUMER = 1,
  OWNER = 2,
}
